import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialStatus } from '../../models/materialstatus/materialstatus.model';
import { MaterialStatusService } from '../../services/material-status.service';
import { GridComponent } from '@progress/kendo-angular-grid';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { DialogUploadComponent } from 'src/app/core/components/dialog-upload/dialog-upload.component';
import { MaterialStatusConstant } from 'src/app/core/constants/material-status.constants';
import { CommonService } from 'src/app/core/services/common.service';
import { RoleConstant } from 'src/app/core/constants/role.constants';

@Component({
    selector: 'app-material-status',
    templateUrl: './material-status.component.html',
    styleUrls: ['./material-status.component.css'],
    standalone: false
})
export class MaterialStatusComponent implements OnInit {
  constructor(private materialStatusService: MaterialStatusService,
    private route: ActivatedRoute,
    public router: Router, private dialogService: DialogService, public commonService: CommonService
  ) { }

  public gridData: MaterialStatus[] = [];
  public globalGridData: MaterialStatus[] = [];
  public checked: true = true;
  public searchText: string = '';
  public showInactive = false;

  ngOnInit() {
    if (this.commonService.getUserRoleName() !== RoleConstant.ESAR_Admin) {
      this.router.navigate(['../../sar'], { relativeTo: this.route });
      return false;
    }
    this.getMaterialStatus();
  }

  getMaterialStatus() {
    this.materialStatusService.getMaterialStatus().subscribe((response: MaterialStatus[]) => {
      this.globalGridData = Object.assign([], response);
      this.updateGrid();
    });
  }

  updateGrid() {
    this.gridData = this.commonService.setupGobalSearch(this.globalGridData, this.showInactive, MaterialStatusConstant.searchFieldName, this.searchText, MaterialStatusConstant.code);
  }

  cancelSearch() {
    this.searchText = '';
    this.updateGrid();
  }

  activeChanged(value: boolean) {
    this.showInactive = value;
    this.updateGrid();
  }
  public exportToExcel(grid: GridComponent): void {
    grid.saveAsExcel();
  }
  manage(isCreate: boolean, isActive: boolean, name: string, id: number, code: string) {
    this.router.navigate(["../manageMaterialStatus"], {
      state: { 'isCreate': isCreate, 'id': id, 'name': name, 'isActive': isActive, 'code': code },
      relativeTo: this.route
    },
    );
  }

  public import(): void {
    const dialog: DialogRef = this.dialogService.open({
      content: DialogUploadComponent
    });

    dialog.result.subscribe((r: any) => {
      if (r.action === "Save") {
        let arr = JSON.parse(r.value).Sheet1 as Array<any>;
        let storageConditions: MaterialStatus[] = arr.map((item: any) => {
          return {
            id: 0,
            name: item['Material Status'].toString(), code: item['UOM Code'].toString(), isActive: item['Is Active'],
            createdBy: item['Created By'], modifiedBy: item['Modified By'],
            createdDateTime: undefined, modifiedDateTime: undefined
          };
        });
        this.materialStatusService.importExcelData(storageConditions).subscribe((response: MaterialStatus) => {
          this.commonService.showNotificationMessage(MaterialStatusConstant.bulkInsertMessage, 'success', 'right')
          this.getMaterialStatus();
        });
      }
    });
  }
}

